/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Query_Keys } from "../../../lib/queryKeys";
import { getBaseQueryKey, mergeQueryKeys } from "../utils/queryKeyHelpers";
import { auditLogRefreshKeys } from "./sharedRefreshKeys";

const baseSalesCategoryKeys = mergeQueryKeys(
  getBaseQueryKey(Query_Keys.sales_categories)
);

// The Daily Manager Logbook detail resolves its sales category labels live from this lookup
// table (SalesBreakdownQuery#names_for), so an import that adds or renames a row changes what
// that page renders. The logbook summary is not listed: it only carries restaurant names.
const salesCategoryImportKeys = mergeQueryKeys(
  baseSalesCategoryKeys,
  getBaseQueryKey(Query_Keys.daily_logbook_detail),
  auditLogRefreshKeys
);

export const salesCategoryMutationKeyGroups = {
  fetch: salesCategoryImportKeys,
};
